<div class="dialog-content">
    <div mat-dialog-title class="dialog-title">
        <span>Update Faulty {{ getFieldLabel() }}</span>
        <button (click)="canceledOption()"><i class="bi bi-x-lg"></i></button>
    </div>
    <div class="underline"></div>

    <ng-container *ngIf="!showEcuBuildInput(); else inputBlock">
        <div>
            <div mat-dialog-content class="dialog-text">
                Are you sure that you want to update this {{ getFieldLabel() }}:
                <strong>{{ data.faultyValue }}</strong>?
            </div>
            <div mat-dialog-actions>
                <button mat-raised-button color="warn" (click)="confirmedOption()">Yes</button>
                <button mat-raised-button class="dialog-btn" (click)="canceledOption()">No</button>
            </div>
        </div>
    </ng-container>

    <ng-template #inputBlock>
        <div>
            <div mat-dialog-content class="dialog-text">
                <p>You have selected {{ data.pureOriginalIds.length }}
                    {{ data.pureOriginalIds.length === 1 ? 'faulty PureOriginal' : 'faulty PureOriginals' }}
                </p>

                <mat-form-field appearance="fill">
                    <mat-label>New {{ getFieldLabel() }}</mat-label>
                    <input matInput [formControl]="newValueControl" [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                            {{ option.correctEcuBuildNames }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <div mat-dialog-actions>
                <button mat-raised-button color="warn"
                        [disabled]="newValueControl.invalid || isLoading()"
                        (click)="submitNewEcuBuild()">
                    <ng-container *ngIf="isLoading(); else normalText">
                        <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                    </ng-container>
                    <ng-template #normalText>Yes</ng-template>
                </button>
                <button mat-raised-button class="dialog-btn" (click)="canceledOption()">No</button>
            </div>
        </div>
    </ng-template>
</div>
